import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/work-schedules'
const RESOURCE_NAME_GROUPS = '/work-schedule-groups'

export default {
  // Crear nuevo horario
  store(data) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}`, data)
  },
  // Listar horarios
  list(filters) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/list`, filters)
  },
  // Obtener horario por id
  show(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  // Actualizar horario por id
  update(id, data) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/${id}`, data)
  },
  // Eliminar horario por id
  destroy(id) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  // Crear agrupación de horarios
  storeGroup(data) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME_GROUPS}`, data)
  },
  // Listar agrupaciones
  listGroups(filters) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME_GROUPS}/list`, filters)
  },
  // Actualizar agrupación
  updateGroup(id, data) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME_GROUPS}/${id}`, data)
  },
  // Eliminar agrupación
  destroyGroup(id) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME_GROUPS}/${id}`)
  },
  // Usuarios de una agrupación
  getGroupUsers(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME_GROUPS}/${id}/users`)
  },
  // Usuarios de un horario
  getScheduleUsers(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}/users`)
  },
}
